import { NgModule } from '@angular/core';
import { Routes, PreloadAllModules, RouterModule } from '@angular/router';

//import { BasicComponent } from './shared/basic/basic.component'
import { PesqComponent } from './results/pesq/pesq.component';
import { PolqaComponent } from './results/polqa/polqa.component';
import { CallEventsComponent } from './results/call-events/call-events.component';
import { VbaComponent } from './results/vba/vba.component';
import { FaxComponent } from './results/fax/fax.component';
import { AudioDelayComponent } from './results/audio-delay/audio-delay.component';

//import { HeaderDemoComponent } from './shared/header-demo/header-demo.component'
import { VacComponent } from './results/vac/vac.component';
import { EmuComponent } from './results/emu/emu.component';
import { NettestrsltsComponent } from './results/nettestrslts/nettestrslts.component';
import { MobinforsltsComponent } from './results/mobinforslts/mobinforslts.component';

import { AnalysisComponent } from './graphics/analysis/analysis.component';
import { CallProcessComponent } from './graphics/call-process/call-process.component';
import { NettestComponent } from './graphics/nettest/nettest.component';

import { NetworkStatusComponent } from './statistics/network-status/network-status.component';
import { VQUADComponent } from './statistics/network-status/vquad/vquad.component';
import { VquadbtfxoComponent } from './statistics/network-status/vquadbtfxo/vquadbtfxo.component';
import { VquadscrparamsComponent } from './statistics/network-status/vquadscrparams/vquadscrparams.component';
import { FileMonitorComponent } from './statistics/network-status/file-monitor/file-monitor.component';
import { VQTComponent } from './statistics/network-status/vqt/vqt.component';
import { MobileComponent } from './statistics/network-status/mobile/mobile.component';
import { CommandCenterComponent } from './statistics/network-status/command-center/command-center.component';

import { CustomReportComponent } from './output-results/custom-report/custom-report.component';
import { GoogleMapComponent } from './output-results/google-map/google-map.component';
import { CustomGmapsMainComponent } from './output-results/custom-gmaps-main/custom-gmaps-main.component';

import { WebviewerconfigComponent } from './configuration/webviewerconfig/webviewerconfig.component';

import { FiltersComponent } from './filters/filters.component';

import { UrlReloadButtonComponent } from './shared/components/url-reload-button/url-reload-button.component';

import { SchedulerStatusComponent } from './statistics/scheduler-status/scheduler-status.component';
import { LoginComponent } from './login/login.component';
import { LicenceCheckComponent } from './login/licence-check/licence-check.component';
import { LoginConfigComponent } from './login/login-config/login-config.component';
import { LogoutComponent } from './login/logout/logout.component';

import { AudioAndDelayStatisticsPieChartComponent } from './statistics/audio-and-delay-statistics-pie-chart/audio-and-delay-statistics-pie-chart.component';
import { VoiceQualityStatisticsPieChartComponent } from './statistics/voice-quality-statistics-pie-chart/voice-quality-statistics-pie-chart.component';
import { LeafletGMapComponent } from './output-results/leaflet-gmap/leaflet-gmap.component';
import { TestJSGoogleMapComponent } from './output-results/test-jsgoogle-map/test-jsgoogle-map.component';
import { VMobileComponent } from './statistics/network-status/v-mobile/v-mobile.component';
import { ITSViewerComponent } from './output-results/itsviewer/itsviewer.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ExploreOptionsComponent } from './shared/components/explore-options/explore-options.component';
import { AdvancedMarkersComponent } from './output-results/advanced-markers/advanced-markers.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login/LicenseCheck', component: LicenceCheckComponent },
  { path: 'login/Config', component: LoginConfigComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },

  { path: 'dashboard/pesq', component: PesqComponent },
  { path: 'dashboard/polqa', component: PolqaComponent },
  { path: 'dashboard/call-events', component: CallEventsComponent },
  { path: 'dashboard/vba', component: VbaComponent },
  { path: 'dashboard/vac', component: VacComponent },
  { path: 'dashboard/fax', component: FaxComponent },
  { path: 'dashboard/audio-delay', component: AudioDelayComponent },

  { path: 'dashboard/nettest', component: NettestrsltsComponent },
  { path: 'dashboard/mobileinfo', component: MobinforsltsComponent },
  { path: 'dashboard/vac', component: VacComponent },
  { path: 'dashboard/emu', component: EmuComponent },

  { path: 'filters/:filter-name', component: FiltersComponent, outlet: 'filterPopup' },
  { path: 'login/Config', component: LoginConfigComponent, outlet: 'popupOutlet' },
  { path: 'help/exploreOptions', component: ExploreOptionsComponent, outlet: 'popupExploreOptions' },

  { path: 'graphics/call-process', component: CallProcessComponent },
  { path: 'graphics/analysis', component: AnalysisComponent },
  { path: 'graphics/nettest-graphs', component: NettestComponent },

  { path: 'statistics/AudioDelayStatsPieChart', component: AudioAndDelayStatisticsPieChartComponent },
  { path: 'statistics/VoiceQualityStatsPieChart', component: VoiceQualityStatisticsPieChartComponent },
  { path: 'statistics/nsvquad', component: VQUADComponent },
  { path: 'statistics/nsvmobile', component: VMobileComponent },
  { path: 'statistics/nsvqt', component: VQTComponent },
  { path: 'statistics/nsmobile', component: MobileComponent },
  { path: 'statistics/nsfilemonitor', component: FileMonitorComponent },
  { path: 'statistics/nscommandcenter', component: CommandCenterComponent },
  { path: 'statistics/scheduler', component: SchedulerStatusComponent },

  { path: 'outputresult/CustomReport', component: CustomReportComponent },
  //{ path: 'outputresult/GoogleMap', component: GoogleMapComponent },
  { path: 'outputresult/LeafletMap', component: LeafletGMapComponent },
  { path: 'outputresult/CustomGMapMain', component: CustomGmapsMainComponent },
  //{ path: 'outputresult/TestJSGMapComponent', component: TestJSGoogleMapComponent },
  { path: 'outputresult/GoogleMap', component: TestJSGoogleMapComponent },
  { path: 'outputresult/AdvGoogleMap', component: AdvancedMarkersComponent },
  { path: 'outputresult/ITSViewer', component: ITSViewerComponent },
 

  //{ path: 'configuration/webviewerconfig', component: WebviewerconfigComponent },

  //{ path: 'refresh', component: UrlReloadButtonComponent },

  { path: 'configuration', loadChildren: () => import('./configuration/webviewerconfig/webviewerconfig.module').then(m => m.WebviewerconfigModule), outlet: 'configPopup' },

  { path: '**', redirectTo: 'dashboard/pesq', pathMatch: 'full' },//path: ''
];

@NgModule({
  //https://medium.com/angular-in-depth/refresh-current-route-in-angular-512a19d58f6e
  //https://www.youtube.com/watch?v=LEI9yrTIrCM
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],//RouterModule.forRoot(ROUTES, { useHash: true, preloadingStrategy: PreloadAllModules }),
  exports: [RouterModule]
})
export class AppRoutingModule { }
